import { Typography } from 'antd';
import { useField } from 'formik';
import { getEffectiveUnitPrice } from 'utils/InvoiceUtils';
import { AppliedAdditionalCharge } from 'store/invoices/types';

type Props = {
    index: number;
    dataTestId: string;
    liabilityGross: number;
};

const NetAmountCell = ({ index, dataTestId, liabilityGross }: Props) => {
    const [field] = useField<AppliedAdditionalCharge>(`additionalCharges.${index}`);
    const charge = field.value;
    const netAmount = getEffectiveUnitPrice(charge, liabilityGross) * (charge.quantity ?? 1);
    return <Typography.Text data-testid={dataTestId}>{netAmount.toFixed(2)}</Typography.Text>;
};

export default NetAmountCell;
